import { useEffect, useState } from 'react';

import './SettingChatbot.css';
import { useRecoilValue } from 'recoil';
import Utils from '@/common/utils/utils';
import CropImage from '@/component/common/form/crop-image/index';
import { corporationAtom } from '@/state/atom/corporationAtom';
import Constant from '@/common/constant/Constant';
import { Storage } from 'aws-amplify';
import { IconButton } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const SettingLogoChatbot = props => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const corporationDetail = useRecoilValue(corporationAtom);
    const { croppedImage, setCroppedImage, errors, setErrors, settingData, setSettingData, setIsEdited, setPreviewSetting, reloadPage, setIsDisableBtnSubmit, logoFileName, setLogoFileName } = props;
    const [inputImage, setInputImage] = useState('');
    const [openCrop, setOpenCrop] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    // const [logoFileName, setLogoFileName] = useState('');
    const [errorImage, setErrorImage] = useState('');
    const [displayIconRemoveImage, setDisplayIconRemoveImage] = useState(false);
    const cropShape = '';
    const aspect = 1 / 1;
    const [isHoverLogoChatbot, setIsHoverLogoChatbot] = useState(false);

    useEffect(() => {
        initLogoData();
    }, [settingData?.sendIcon, reloadPage]);

    useEffect(() => {
        if (croppedImage) {
            setPreviewSetting(prev => ({ ...prev, sendIcon: croppedImage.image }))
        }
    }, [croppedImage]);

    useEffect(() => {
        let errorsClone = { ...errors };
        if (errorImage) {
            errorsClone.sendIcon = errorImage;
        } else {
            delete errorsClone.sendIcon;
        }
        setErrors(errorsClone);
    }, [errorImage]);

    const initLogoData = async () => {
        let logoImg = '';
        if (croppedImage) {
            logoImg = croppedImage.image;
            setLogoFileName(croppedImage.name);
        }
        else if (settingData?.sendIcon && settingData?.sendIcon !== Constant.SETTING_CHAT_BOT.SEND_LOGO) {
            setLogoFileName(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name)
            );
            // get logo preview
            logoImg = await Storage.get(settingData?.sendIcon);
            setDisplayIconRemoveImage(true)
        } else {
            // get logo preview
            logoImg = Constant.SETTING_CHAT_BOT.SEND_LOGO
            setDisplayIconRemoveImage(false)
        }
        setPreviewSetting(prev => ({...prev, sendIcon: logoImg}));
        setImagePreview(logoImg);
    };

    const onLogoFileChange = event => {
        let file = event.target.files[0];
        if (file) {
            setLogoFileName(file.name);
        } else {
            setLogoFileName('');
            return;
        }
        if (!validateUpdateImage(file)) return;
        if (file) {
            setLogoFileName(file.name);
            Utils.readFileAsArrayBuffer(file).then(reader => {
                const buffer = new Buffer(reader.result);
                const imgBase64 = buffer.toString('base64');
                setInputImage(`data:${file.type};base64,${imgBase64}`);
                setOpenCrop(true);
                event.target.value = '';
            });
        }
        
        setIsEdited(true)
        setDisplayIconRemoveImage(true)

        if (!Utils.isEmptyObject(errors)) return setIsDisableBtnSubmit(true);
        setIsDisableBtnSubmit(false);
        // setImagePreview('');
    };

    const onCloseCropEditor = () => {
        setOpenCrop(false);
        if (settingData?.sendIcon && settingData?.sendIcon != Constant.SETTING_CHAT_BOT.SEND_LOGO) {
            setLogoFileName(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corporationDetail.name)
            );
        } else {
            setLogoFileName();
            setPreviewSetting(prev => ({...prev, sendIcon:  Constant.SETTING_CHAT_BOT.SEND_LOGO}));
            setImagePreview( Constant.SETTING_CHAT_BOT.SEND_LOGO);
        }
    }

    const onRemoveLogo = async () => {
        let logo = Constant.SETTING_CHAT_BOT.SEND_LOGO;
        setImagePreview(logo);
        setLogoFileName('');
        setErrorImage('');
        setCroppedImage(null);
        setSettingData(prev => {
            prev.sendIcon = Constant.SETTING_CHAT_BOT.SEND_LOGO;
            return prev;
        });
        setPreviewSetting(prev => ({ ...prev, sendIcon: Constant.SETTING_CHAT_BOT.SEND_LOGO }))
        setIsEdited(true)
        setDisplayIconRemoveImage(false)
        setIsHoverLogoChatbot(false)

       if (!Utils.isEmptyObject(errors)) return setIsDisableBtnSubmit(true);
       setIsDisableBtnSubmit(false);
    };

    const validateUpdateImage = file => {
        if (!file || !file?.size) return false;
        let imageExtension = file.name
            ?.split('.')
            ?.pop()
            ?.toLowerCase();
        const acceptedFileExtension = [
            'tiff',
            'tif',
            'jpeg',
            'jpg',
            'jpe',
            'jfif',
            'jfi',
            'jif',
            'bmp',
            'gif',
            'png'
        ];
        if (!acceptedFileExtension.includes(imageExtension)) {
            setErrorImage('USER01MSG007');
            return false;
        }
        let sizeMB = Utils.convertByteToMB(file.size)
        if (sizeMB > 5) {
            setErrorImage(trI18n('COMMSG035').replace('{{fileSize}}', 5));
            return false;
        }
        return true;
    };

    return (
        <div className="embeddedCode">
            <div className="embeddedCode-label">{trI18n('PLKNOWLB031')}</div>
            <div className="logo-wrap">
                <div className="logo-image"
                    onMouseEnter={() => setIsHoverLogoChatbot(true)}
                    onMouseLeave={() => setIsHoverLogoChatbot(false)}>
                    {(displayIconRemoveImage && isHoverLogoChatbot) && (
                        <div>
                            <IconButton onClick={onRemoveLogo} className="itemDelete">
                                <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                            </IconButton>
                        </div>
                    )}
                    <div className="image-preview">
                        <img src={imagePreview} alt="" />
                    </div>
                </div>
                <div className="logo-name">
                    <input
                        onChange={onLogoFileChange}
                        accept="image/png, image/gif, image/jpeg, image/tiff, image/bmp"
                        className="updateFile"
                        id="chatbot-kn-site-setting-send-icon"
                        type="file"
                    />
                    <label htmlFor="chatbot-kn-site-setting-send-icon">
                        <div className="upload-logo">{tr('画像ファイルを選択')}</div>
                    </label>

                    {errorImage && <div className="imageError">{trI18n(errorImage)}</div>}
                </div>

                <CropImage
                    openCrop={openCrop}
                    setOpenCrop={setOpenCrop}
                    onCloseCallback={onCloseCropEditor}
                    aspect={aspect}
                    cropShape={cropShape}
                    inputImage={inputImage}
                    setInputImage={setInputImage}
                    setCroppedImage={props.setCroppedImage}
                    setErrorImage={setErrorImage}
                    setImagePreview={setImagePreview}
                />
            </div>
        </div>
    );
};

export default SettingLogoChatbot;